import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { restoreAudience } from 'scenes/CustomAudiences/Audiences/sources/audiences';

import { restore } from '../queryKeyFactory';

export const useRestoreAudience = () => {
  const showModal = useScreenModalV2(ConfirmDialog);

  const restoreAUMutation = useMutation(restore(), restoreAudience, {
    successMessage: (_, params) => `Audience «${params.name}» was restored`,
  });

  const handleAction = async ({ id, name }) => {
    await showModal({
      title: `Restore Audience?`,
      confirmActionLabel: 'Restore',
      bodyText: `${name}`,
    });
    await restoreAUMutation.mutateAsync({ id, name });
  };

  return [handleAction, restoreAUMutation];
};
